import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    ".Mui-completed": {
      border: "2px solid blue",
    },
  },
  gridMenuTop: {
    position: "fixed",
    zIndex: "999",
    top: "0px",
    left: "0rem",
    width: "100%",
    background: "white",
  },
  containerTimiline: {
    display: "flex",
    justifyContent: "space-evenly",
  },
  image: {
    width: "220px",
    marginLeft: "8px",
  },
  boxImg: {
    display: "flex",
    justifyContent: "space-evenly",
    margin: "1rem 0 1rem 0 !important",
  },
  stepMenu: {
    "&:hover": {
      background: "#E8E8E8",
    },
    padding: "0.5rem",
    borderRadius: "5px",
    //background: 'red'
  },
}));
